import { CommonModule } from '@angular/common';
import { Component, computed, Input } from '@angular/core';
import { ProductStockComponent } from '@b2b/components/product/product-stock/product-stock.component';
import { SkeletonLoadingComponent } from '@shared/components/skeleton-loading/skeleton-loading.component';
import { ProductService } from '@b2b/features/product/core/services/product.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { initialStatus } from '@app/core/models/request-status.model';

export enum PRICE_SIZE {
  SM = 'price-sm',
  MD = 'price-md',
}

@Component({
  selector: 'product-price',
  imports: [CommonModule, ProductStockComponent, SkeletonLoadingComponent, TranslateModule],
  templateUrl: './price.component.html',
  styleUrl: './price.component.scss',
})
export class ProductPriceComponent {
  @Input() size: PRICE_SIZE = PRICE_SIZE.MD;
  @Input() price = toSignal(this.productService.getPrice(), {
    initialValue: { ...initialStatus, data: null },
  });
  @Input() stock = toSignal(this.productService.getStock(), {
    initialValue: { ...initialStatus, data: null },
  });

  readonly product = toSignal(this.productService.getProduct(), {
    initialValue: { ...initialStatus, data: null },
  });

  showStrikethrough = computed(() => {
    const pricing = this.price()?.data;
    if (!pricing) return false;
    return pricing.finalPrice < pricing.price;
  });

  constructor(private productService: ProductService) {}
}
